import { forwardRef, useImperativeHandle, useRef } from 'react'

import { IconComponent } from '../../types'
import { Button } from '../Button'
import { Dialog } from '../Dialog'

type ConfirmDialogProps = {
  title?: string
  message?: string
  confirmLabel?: string
  confirmIcon?: IconComponent
  cancelLabel?: string
  children?: React.ReactNode,
  onConfirm: any
}

export const ConfirmDialog = forwardRef<
  React.ElementRef<typeof Dialog<boolean>>,
  ConfirmDialogProps
>(({ title,onConfirm, message, cancelLabel, confirmLabel, confirmIcon, children }, ref) => {
  const dialog = useRef<React.ElementRef<typeof Dialog<boolean>>>(null)

  useImperativeHandle(
    ref,
    () => ({
      open: dialog.current!.open,
      close: dialog.current!.close
    }),
    []
  )

  const confirm = () => onConfirm() && dialog.current!.close(true)

  const cancel = () => dialog.current!.close(false)

  return (
    <Dialog ref={dialog} title={title} withCloseButton>
      {children || (message && <div className="mb-8">{children || message}</div>)}

      <div className="flex items-center gap-4">
        <Button label={cancelLabel || 'Cancel'} onClick={cancel} className="flex-auto w-1/2" />

        <Button
          label={confirmLabel || 'OK'}
          prefixIcon={confirmIcon}
          variant="primary"
          onClick={confirm}
          className="flex-auto w-1/2 max-h-[32px]"
        />
      </div>
    </Dialog>
  )
})
